import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Alias extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "alias";
    }
}

export function Alias$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.Alias", void 0, Alias, Metadata_StringCategory$reflection());
}

export function Alias_$ctor_Z721C83C5(aName) {
    return new Alias(aName);
}

export class Agegroup extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "agegroup";
    }
}

export function Agegroup$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.Agegroup", void 0, Agegroup, Metadata_StringCategory$reflection());
}

export function Agegroup_$ctor_Z721C83C5(aName) {
    return new Agegroup(aName);
}

export class Age extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age";
    }
}

export function Age$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.Age", void 0, Age, Metadata_NumberCategory$reflection());
}

export function Age_$ctor_Z721C83C5(aName) {
    return new Age(aName);
}

export class BirthYear extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "birth_year";
    }
}

export function BirthYear$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.BirthYear", void 0, BirthYear, Metadata_NumberCategory$reflection());
}

export function BirthYear_$ctor_Z721C83C5(aName) {
    return new BirthYear(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Place extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "place";
    }
}

export function Place$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.Place", void 0, Place, Metadata_StringCategory$reflection());
}

export function Place_$ctor_Z721C83C5(aName) {
    return new Place(aName);
}

export class Baiki extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "baiki";
    }
}

export function Baiki$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.Baiki", void 0, Baiki, Metadata_StringCategory$reflection());
}

export function Baiki_$ctor_Z721C83C5(aName) {
    return new Baiki(aName);
}

export class District1960 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "district_1960";
    }
}

export function District1960$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.District1960", void 0, District1960, Metadata_StringCategory$reflection());
}

export function District1960_$ctor_Z721C83C5(aName) {
    return new District1960(aName);
}

export class District1978 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "district_1978";
    }
}

export function District1978$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.District1978", void 0, District1978, Metadata_StringCategory$reflection());
}

export function District1978_$ctor_Z721C83C5(aName) {
    return new District1978(aName);
}

export class DistrictSami1960 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "district_sami_1960";
    }
}

export function DistrictSami1960$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.DistrictSami1960", void 0, DistrictSami1960, Metadata_StringCategory$reflection());
}

export function DistrictSami1960_$ctor_Z721C83C5(aName) {
    return new DistrictSami1960(aName);
}

export class DistrictSami1978 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "district_sami_1978";
    }
}

export function DistrictSami1978$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.DistrictSami1978", void 0, DistrictSami1978, Metadata_StringCategory$reflection());
}

export function DistrictSami1978_$ctor_Z721C83C5(aName) {
    return new DistrictSami1978(aName);
}

export class County extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "county";
    }
}

export function County$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.County", void 0, County, Metadata_StringCategory$reflection());
}

export function County_$ctor_Z721C83C5(aName) {
    return new County(aName);
}

export class CountySami extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "county_sami";
    }
}

export function CountySami$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.CountySami", void 0, CountySami, Metadata_StringCategory$reflection());
}

export function CountySami_$ctor_Z721C83C5(aName) {
    return new CountySami(aName);
}

export class Occupation extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "occupation";
    }
}

export function Occupation$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.Occupation", void 0, Occupation, Metadata_StringCategory$reflection());
}

export function Occupation_$ctor_Z721C83C5(aName) {
    return new Occupation(aName);
}

export class HdFilenameHd extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hd_filename_hd";
    }
}

export function HdFilenameHd$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.HdFilenameHd", void 0, HdFilenameHd, Metadata_StringCategory$reflection());
}

export function HdFilenameHd_$ctor_Z721C83C5(aName) {
    return new HdFilenameHd(aName);
}

export class HdOriginalFileHd extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hd_original_file_hd";
    }
}

export function HdOriginalFileHd$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.HdOriginalFileHd", void 0, HdOriginalFileHd, Metadata_StringCategory$reflection());
}

export function HdOriginalFileHd_$ctor_Z721C83C5(aName) {
    return new HdOriginalFileHd(aName);
}

export class RecYear extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "rec_year";
    }
}

export function RecYear$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.RecYear", void 0, RecYear, Metadata_NumberCategory$reflection());
}

export function RecYear_$ctor_Z721C83C5(aName) {
    return new RecYear(aName);
}

export class HdOwnerHd extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hd_owner_hd";
    }
}

export function HdOwnerHd$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.HdOwnerHd", void 0, HdOwnerHd, Metadata_StringCategory$reflection());
}

export function HdOwnerHd_$ctor_Z721C83C5(aName) {
    return new HdOwnerHd(aName);
}

export class HdKeywordsHd extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hd_keywords_hd";
    }
}

export function HdKeywordsHd$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.HdKeywordsHd", void 0, HdKeywordsHd, Metadata_StringCategory$reflection());
}

export function HdKeywordsHd_$ctor_Z721C83C5(aName) {
    return new HdKeywordsHd(aName);
}

export class HdInterviewerHd extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hd_interviewer_hd";
    }
}

export function HdInterviewerHd$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.HdInterviewerHd", void 0, HdInterviewerHd, Metadata_StringCategory$reflection());
}

export function HdInterviewerHd_$ctor_Z721C83C5(aName) {
    return new HdInterviewerHd(aName);
}

export class HdComment1Hd extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hd_comment1_hd";
    }
}

export function HdComment1Hd$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.HdComment1Hd", void 0, HdComment1Hd, Metadata_StringCategory$reflection());
}

export function HdComment1Hd_$ctor_Z721C83C5(aName) {
    return new HdComment1Hd(aName);
}

export class HdComment2Hd extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hd_comment2_hd";
    }
}

export function HdComment2Hd$reflection() {
    return class_type("Corpora.Saami.MetadataCategories.HdComment2Hd", void 0, HdComment2Hd, Metadata_StringCategory$reflection());
}

export function HdComment2Hd_$ctor_Z721C83C5(aName) {
    return new HdComment2Hd(aName);
}

